<script setup lang="ts">
import { computed, ref } from 'vue';
import BaseFormInput from '@/components/UI/Input/BaseFormInput.vue';
import { InspectedBuilding } from '@/models/InspectedBuilding';
import { ProductEstimationTypes } from '@/enums/device';

const props = defineProps<{
  inspectedBuilding: InspectedBuilding;
}>();

const emit = defineEmits(['update:estimations']);

const inputRefs = ref<Record<string, any>>({});

const focusInput = (customizedNumber: string) => {
  const baseFormInput = inputRefs.value[customizedNumber];
  if (baseFormInput && baseFormInput.$el) {
    const inputElement = baseFormInput.$el.querySelector('input');
    if (inputElement) inputElement.focus();
  }
};

const tableRows = computed(() => {
  const sorted = [...props.inspectedBuilding.productEstimations];
  sorted.sort((a, b) => {
    if (a.customizedNumber === '42001') return -1;
    if (b.customizedNumber === '42001') return 1;
    return a.customizedNumber.localeCompare(b.customizedNumber);
  });
  return sorted;
});
</script>

<template>
  <table
    class="min-w-full bg-light-2 dark:bg-dark-2 rounded-lg overflow-hidden"
  >
    <thead class="bg-light-2 dark:bg-dark-2 text-base">
      <tr>
        <th class="py-3 px-4 text-left">Bezeichnung</th>
        <th class="py-3 px-4 text-left">Artikel Nr.</th>
        <th class="py-3 px-4 text-left">Stückzahl (System)</th>
        <th class="py-3 px-4 text-left">Korrektur</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="row in tableRows"
        :key="row.customizedNumber"
        class="text-base"
      >
        <td class="py-2 px-4">
          {{
            ProductEstimationTypes.find((type) => type.value === row.type).name
          }}
        </td>
        <td class="py-2 px-4">{{ row.customizedNumber }}</td>
        <td class="py-2 px-4">{{ row.count }}</td>
        <td class="p-0 flex items-center">
          <BaseFormInput
            :ref="(el) => (inputRefs[row.customizedNumber] = el)"
            v-model.number="row.estimation"
            type="number"
            pattern="[0-9]*"
            inputmode="numeric"
            class="pb-0! pt-0! w-full"
            :test-id="`input-estimation-${row.customizedNumber}`"
          />
          <em
            class="mdi mdi-pencil mx-2 cursor-pointer text-xl text-primary-2"
            @click="() => focusInput(row.customizedNumber)"
          ></em>
        </td>
      </tr>
      <tr v-if="tableRows.length === 0">
        <td colspan="4" class="py-4 px-4 text-sm text-center">
          Keine Adapter gefunden
        </td>
      </tr>
    </tbody>
  </table>
</template>
